import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import { Link } from 'react-router-dom'
import DataGridWithSearch from 'components/generic/datagrid/DataGridWithSearch'
import { trackEvent } from 'utils/tracking'
import { CHURN_ZERO_EVENTS as cz } from 'utils/constants'
import { useBuildReportsList } from './reportsHelper'
import { useSelector } from 'react-redux'

const COLUMNS = [
  {
    field: 'name',
    headerName: 'Report Name',
    width: 400,
    renderCell: params => (
      <Link
        to={`${params.row?.id}`}
        onClick={() => {
          trackEvent({
            eventName: cz.VIEW_REPORTS,
            description: params.value,
          })
        }}
      >
        {params.row?.name}
      </Link>
    ),
  },
  {
    field: 'description',
    headerName: 'Description',
    flex: 1,
  },
  {
    field: 'category',
    headerName: 'Category',
    flex: 1,
  },
]

const ReportsContainer = () => {
  const reports = useBuildReportsList()
  const inOrgMode = useSelector(state => state.ui.inOrgMode)

  const filteredReports = useMemo(() => {
    if (!inOrgMode) return reports

    // if in org mode and the orgLevelReports is undefined or null, dont show that row
    return reports.filter(report => report.orgLevelReportId !== null)
  }, [reports, inOrgMode])

  return (
    <Box p={3} sx={{ height: '100%' }} container flexDirection="column">
      <DataGridWithSearch
        rows={filteredReports}
        loading={false}
        columns={COLUMNS}
        textSearchPlaceholder="Search reports"
        customPageSize={50}
      />
    </Box>
  )
}

export default ReportsContainer
